import { context } from '@wikia/ad-engine';

export function getGumgumContext(): object {
	const floorAdhesionConfigs = context.get('experiments.persistentAdhesionExperiment')
		? {}
		: {
				floor_adhesion: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.floor_adhesion ?? [
						[300, 50],
						[320, 50],
						[320, 100],
					],
					zone: 'vbzbl1nw',
					slot: '1223125',
				},
			};

	return {
		enabled: false,
		slots: {
			...(context.get('gumgum.floorAdhesion') ? floorAdhesionConfigs : {}),
		},
	};
}
